(function ($) {

    $(document).ready(function () {
        var container = $(".top-stories .items");
        container.isotope({
            itemSelector: '.item',
            percentPosition: true,
            layoutMode: 'packery'
        });
    });


    $(window).on('load', function () {

    });

    $(document).ready(function () {
        // if ($('.archive.category').length === 1 && window.location.hash) {
        //
        //     var hash = window.location.hash;
        //
        //     if ($(hash).length) {
        //         $('html, body').animate({
        //             scrollTop: $(hash).offset().top
        //         }, 500);
        //     }
        // } else {
        //     return;
        // }
    });
})(jQuery);


// WEBPACK FOOTER //
// ./src/js/custom/customBlog.es6